import type { Invoice } from "@medplum/fhirtypes";

import { QuiltedHealthIdentifierSystems } from "@/fhir/enums/quilted-health";
import { identifierValues } from "@/utils/medplum";

/**
 * The practice-facing statement number carried on a resource's identifiers.
 *
 * Takes any resource with an `identifier` list rather than an `Invoice`, because a
 * `PaymentReconciliation` records the statement it settles under the same identifier system and the
 * ledger surfaces read the number off both.
 *
 * @param resource The resource whose statement number to read.
 * @returns The first statement number found, or `undefined` when the resource carries none.
 */
export function statementNumberOf(resource: {
  identifier?: Invoice["identifier"];
}): string | undefined {
  return identifierValues(resource, QuiltedHealthIdentifierSystems.InvoiceIdentifier)[0];
}
